module.exports = __webpack_public_path__ + "img/xhz.22e1dff2.png";